/* eslint-disable */
import { assetImages } from "constants";
import React from "react";
import { Link } from "react-router-dom";

// import use translation ------------------------------
import { useTranslation } from "react-i18next";

const CongratsModal = () => {
  const { t } = useTranslation(); // translation marker

  return (
    <div className="conatct_modal success_popup">
      <div
        className="modal fade"
        id="congrats_success_mdl"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-body py-4 px-4">
              <div className="success_graphics text-center mb-3">
                <img src={assetImages.submitTickSvg} alt="" />
              </div>
              <div className="success_text text-center">
                <h3>Congratulations!</h3>
                <p className="text-primary-gray mt-3 fs-sm fw-medium">
                  You are now part of Artslob
                </p>
                <div className="btns_group d-flex align-items-center justify-content-center gap-2 mt-3">
                  <Link to="#" data-bs-dismiss="modal" className="btn">
                    Close
                  </Link>
                  <Link
                    to="#"
                    data-bs-dismiss="modal"
                    data-bs-target="#login_modal"
                    data-bs-toggle="modal"
                    className="btn primary-btn"
                  >
                    Let’s Begin
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CongratsModal;
